"use client";

import { usePathname } from "next/navigation";
import { useReportWebVitals } from "next/web-vitals";
import { useEffect } from "react";

import { finishNavigation } from "@/lib/telemetry/browser-navigation";
import { reportWebVital, type VitalMetric } from "@/lib/telemetry/browser";

// Conductor telemetry in the browser (lib/telemetry/browser.ts): Web Vitals
// through Next's useReportWebVitals, and the end of a client-side navigation
// (its start comes from instrumentation-client.ts onRouterTransitionStart).
// Rendered once by the root layout; a no-op unless <html data-telemetry="1">.

// A stable reference, so Next doesn't report the same metrics again.
const onVital = (metric: VitalMetric) => reportWebVital(metric);

export function TelemetryReporter() {
  useReportWebVitals(onVital);
  const pathname = usePathname();
  useEffect(() => {
    finishNavigation();
  }, [pathname]);
  return null;
}
